export default __webpack_public_path__ + "static/media/Group 8518.55d3059f.svg";